import { ProfileModel } from 'src/app/domain/models/profile.model';

export interface ProfileState {
    profile: ProfileModel;
}

export const initialProfileState: ProfileState = {
    profile: {} as ProfileModel,
};
